import type { AccessLegitimacyEnvelope } from '@dawn/feature-config';
import { keepPreviousData, useQuery, type UseQueryResult } from '@tanstack/react-query';

import type { AccessLegitimacyRequestParams } from '@/lib/access-legitimacy-params';
import { dashboardApi } from '@/lib/api';

import { queryKeys } from './query-keys';

/**
 * Events-grid query. Keyed on the full request-param object so any param change
 * refetches. `keepPreviousData` keeps the previous page visible while the next
 * loads (PRD story 18); `staleTime` lets toggling back to a prior filter
 * combination resolve from cache instantly.
 */
export function useAccessLegitimacyQuery(
  params: AccessLegitimacyRequestParams
): UseQueryResult<AccessLegitimacyEnvelope> {
  return useQuery({
    queryKey: queryKeys.accessLegitimacy.grid(params),
    queryFn: ({ signal }) => dashboardApi.getAccessLegitimacy(params, signal),
    placeholderData: keepPreviousData,
    staleTime: 30_000,
  });
}
